// import React, { useRef, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { PDFDocument } from "pdf-lib";
// import SignaturePad from "react-signature-canvas";

// function CustomPDFModal(props) {
//     const [showPdf, setShowPdf] = useState(false);
//     const [pdfUrl, setPdfUrl] = useState(null);
//     const sigPadRef = useRef();
  
//     // Your base PDF (put in public folder or load from API)
//   const samplePdfUrl = "/file.pdf";
  
//     const handleShow = () => {
//       setPdfUrl(samplePdfUrl);
//       setShowPdf(true);
//     };
  
//     const handleClose = () => {
//       setShowPdf(false);
//       setPdfUrl(null);
//     };
  
//     const handleClear = () => {
//       sigPadRef.current.clear();
//     };
  
//     // 👉 Preview PDF with signature stamped in last page
//     const handleSignPreview = async () => {
//       if (sigPadRef.current.isEmpty()) {
//         alert("Please add a signature first.");
//         return;
//       }
  
//       const signatureDataUrl = sigPadRef.current
//         .getCanvas()
//         .toDataURL("image/png");
//       const signatureBytes = await fetch(signatureDataUrl).then((res) =>
//         res.arrayBuffer()
//       );
  
//       const existingPdfBytes = await fetch(samplePdfUrl).then((res) =>
//         res.arrayBuffer()
//       );
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
  
//       const sigImage = await pdfDoc.embedPng(signatureBytes);
//       const pages = pdfDoc.getPages();
//       const lastPage = pages[pages.length - 1];
//       const { width } = lastPage.getSize();
  
//       lastPage.drawImage(sigImage, {
//         x: width - 200,
//         y: 75,
//         width: 125,
//         height: 60,
//       });
  
//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
  
//       // 👉 Update preview with signed version
//       setPdfUrl(url);
//     };
  
//     // 👉 Download the already signed PDF
//     const handleDownload = () => {
//       if (!pdfUrl) return;
//       const link = document.createElement("a");
//       link.href = pdfUrl;
//       link.download = "signed.pdf";
//       link.click();
//     };
  
//   return props.modalState !== "signAndResend" ? (
//     <Modal
//       {...props}
//       size="lg"
//       aria-labelledby="contained-modal-title-vcenter"
//       centered
//     >
//       <Modal.Body>
//            {/* PDF Preview */}
//            {pdfUrl && (
//              <iframe
//                src={pdfUrl}
//                title="pdf-preview"
//                style={{ width: "100%", height: "80vh" }}
//              ></iframe>
//            )}
 
//            <h5 className="mt-3">Draw Signature:</h5>
//            <SignaturePad
//              ref={sigPadRef}
//              penColor="black"
//              canvasProps={{
//                width: 600,
//                height: 150,
//                style: { border: "1px solid #ccc", display: "block" },
//              }}
//            />
//            <Button
//              variant="secondary"
//              size="sm"
//              onClick={handleClear}
//              className="mt-2"
//            >
//              Clear
//            </Button>
//          </Modal.Body>
//          <Modal.Footer>
//            <Button variant="secondary" onClick={handleClose}>
//              Close
//            </Button>
//            <Button variant="warning" onClick={handleSignPreview}>
//              Preview Signature
//            </Button>
//            <Button variant="success" onClick={handleDownload}>
//              Download Signed PDF
//            </Button>
//          </Modal.Footer>
//     </Modal>
//   ) : (
//     <Modal
//       {...props}
//       size="lg"
//       aria-labelledby="contained-modal-title-vcenter"
//       centered
//     >
//       <Modal.Header closeButton>
//         <Modal.Title id="contained-modal-title-vcenter">
//           Default Modal
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <h4>Default Content</h4>
//         <p>
//           Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
//           dapibus ac facilisis in, egestas eget quam.
//         </p>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button onClick={props.onHide}>Close</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

// export default CustomPDFModal;

import React, { useRef, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { PDFDocument } from "pdf-lib";
import SignaturePad from "react-signature-canvas";
import { useSelector } from "react-redux";

function CustomPDFModal(props) {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const sigPadRef = useRef();
    const { currentLocal } = useSelector((state) => state.currentLocal);
  const inputRef = useRef(null);
const [file, setFile] = useState(null)
  // 👉 Put your PDF file in "public/file.pdf"
  const samplePdfUrl = "/file.pdf";

  // Load PDF automatically when modal opens (only in signAndResend mode)
  useEffect(() => {
    if (props.show && props.modalState !== "signAndResend") {
      setPdfUrl(samplePdfUrl);
    } else {
      setPdfUrl(null);
    }
  }, [props.show, props.modalState]);

  const handleClear = () => {
    sigPadRef.current.clear();
  };

  // 👉 Preview PDF with signature stamped in last page
  const handleSignPreview = async () => {
    if (sigPadRef.current.isEmpty()) {
      alert("Please add a signature first.");
      return;
    }

    const signatureDataUrl = sigPadRef.current
      .getCanvas()
      .toDataURL("image/png");
    const signatureBytes = await fetch(signatureDataUrl).then((res) =>
      res.arrayBuffer()
    );

    const existingPdfBytes = await fetch(samplePdfUrl).then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const sigImage = await pdfDoc.embedPng(signatureBytes);
    const pages = pdfDoc.getPages();
    const lastPage = pages[pages.length - 1];
    const { width } = lastPage.getSize();

    lastPage.drawImage(sigImage, {
      x: width - 200,
      y: 75,
      width: 125,
      height: 60,
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    // 👉 Update preview with signed version
    setPdfUrl(url);
       if (props.onSigned) {
      const file = new File([blob], "signed.pdf", { type: "application/pdf" });
      props.onSigned(file);
    }
  };

  // 👉 Download the already signed PDF
  const handleDownload = () => {
    if (!pdfUrl) return;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "signed.pdf";
    link.click();
  };
  const onFileChange = (e) => {
    setFile(e.target.files[0] || null);
  };
  // ✅ Show SIGN modal only when modalState === "signAndResend"
  return props.modalState !== "signAndResend" ? (
  <Modal {...props} size="lg" centered>
    <Modal.Body>
<div className="h-100">
        {/* PDF Preview */}
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="pdf-preview"
          style={{ width: "100%", height: "80vh" }}
        ></iframe>
      )}

      <h5 className="mt-3">{currentLocal.home.signature}:</h5>
      <SignaturePad
        ref={sigPadRef}
        penColor="black"
        canvasProps={{
          width: 600,
          height: 150,
          style: { border: "1px solid #ccc", display: "block" },
        }}
      />
      <Button
        variant="secondary"
        size="sm"
        onClick={handleClear}
        className="mt-2"
      >
        {currentLocal.home.delete}
      </Button>
</div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={props.onHide}>
        {currentLocal.home.close}
      </Button>
      <Button variant="warning" onClick={handleSignPreview}>
        {currentLocal.home.PreviewSignature}
      </Button>
      <Button variant="success" onClick={handleDownload}>
        {currentLocal.home.downloadSignedPdf}
      </Button>
    </Modal.Footer>
  </Modal>

  ) : (
    <Modal {...props} size="md" centered>

   <Modal.Body>
          <div style={props.modalState==="signatureOnline"?{ width: "100%", height: "80vh", overflowY: "auto" }:{width: "100%"}}>


            <h5 className="mb-4 ">{currentLocal.home.signAndResend_ar}</h5>
            <h5 className="mb-4 text-decoration-underline"style={{cursor:"pointer"}}
                      onClick={async () => {
            try {
              // 1. Fetch the PDF
              const response = await fetch("/file.pdf"); // must be in public folder
              const blob = await response.blob();

              // 2. Create a File object (so it behaves like an uploaded file)
              const file = new File([blob], "file.pdf", { type: "application/pdf" });

              // 3. Save to state
              setPdfFile(file);          // <--- now you can send this with FormData

              // 4. Trigger browser download (optional)
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "file.pdf";
              link.click();

            } catch (err) {
              console.error("Failed to load PDF:", err);
            }
          }}
            >{currentLocal.home.downloadpdf}</h5>
            {/* <p> sign pdf and resed it</p> */}
            <div>
              {/* <label>{currentLocal.home.PickPDF} </label> */}
              {/* <input type="file" accept="application/pdf" onChange={onFileChange} /> */}
              <input
                type="file"
                accept="application/pdf"
                ref={inputRef}
                style={{ display: "none" }}
                onChange={onFileChange}
              />
              <div
                style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                onClick={() => inputRef.current.click()}
              >
                {file ?
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
  <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
</svg>
                  :
                  <>
           <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" className="bi bi-file-pdf" viewBox="0 0 16 16">
  <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"/>
  <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
</svg>
                  </>
                }

              </div>
            </div>
          </div>
        </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"
                    className="btn "
                    style={{ backgroundColor: "#e63967", border: "1px solid #e63967" }}
                    onClick={async () => {
                             if (props.onSigned) {
      props.onSigned(file);
    }

props.onHide();

                    }}
                    // disabled={!file} 
                  >
                    {currentLocal.home.send}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={()=>props.onHide()}
                  >
                    {currentLocal.home.close}
                  </Button>
        
        
                </Modal.Footer>
    </Modal>
  );
}

export default CustomPDFModal;

